'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation: ', ';\n  border: ', ';\n  border-left: ', ';\n  border-radius: 50%;\n  font-size: ', ';\n  height: 10em;\n  margin: 60px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 10em;\n\n  &:after {\n    border-radius: 50%;\n    height: 10em;\n    width: 10em;\n  }\n'], ['\n  animation: ', ';\n  border: ', ';\n  border-left: ', ';\n  border-radius: 50%;\n  font-size: ', ';\n  height: 10em;\n  margin: 60px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 10em;\n\n  &:after {\n    border-radius: 50%;\n    height: 10em;\n    width: 10em;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var loading = (0, _styledComponents.keyframes)(_templateObject);

function getColor(props) {
  var d = document.createElement('div');
  d.style.color = props.color;
  document.body.appendChild(d);
  var rgbcolor = window.getComputedStyle(d).color;
  var match = /rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*\d+[.d+]*)*\)/g.exec(rgbcolor);
  var color = match[1] + ', ' + match[2] + ', ' + match[3];
  return color;
}

var RotateSpin = _styledComponents2.default.div(_templateObject2, function (props) {
  return loading + ' ' + props.duration + 's infinite linear';
}, function (props) {
  return '1.1em solid rgba(' + getColor(props) + ', 0.2)';
}, function (props) {
  return '1.1em solid ' + props.color;
}, function (props) {
  return props.size + 'px';
});

exports.default = RotateSpin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-loaders2/dist/rotate-spin/RotateSpin.js
// module id = 561
// module chunks = 0